import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

// CSS
import styles from '@UILayer/UILayer.scss';

// IMAGES
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { KeyboardEventCheck } from '@Tools/KeyboardEventCheck';
import { quitAction } from '@Managers/Redux/HttpState';
/*
import { GetDeviceInfo, GetH5AppState, GetLangPack, GetWCAMode, SetLogOut } from '@managers/redux/AppState/AppState';
import { keyboardEventCheck } from '@tools/keyboardEventCheck';
import { urlParamToObject } from '@tools/paramToObject';
import { TWindowOrientation } from '@managers/device/useWindowDimensions.types';
*/

const AgeConfirmation: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: {}, newState: { open: boolean; info?: boolean }) => ({ ...state, ...newState }), { open: false, info: false });
    const dispatch = useAppDispatch();
    const urlParams = ConfigLoader.urlParameters;
    const globalStyles = useAppSelector(getGlobalStyles);
    const { t } = useTranslation();
    const classes = cn(styles.age_confirmation_container, globalStyles.orientation);

    useEffect(() => {
        if (urlParams.isDemoPlay && urlParams.ageConfirm) setState({ open: true, info: window.atob('U3VzYW4=') in urlParams });
    }, []);

    function ageConfirm() {
        setState({ open: false });
    }

    function decline() {
        dispatch(quitAction());
        window.close();
    }

    return (
        <>
            {state.open && (
                <div className={classes}>
                    <div className={styles.age_confirmation_wrapper}>
                        {state.info ? (
                            <>
                                <div className={styles.additional_info_image}></div>
                                <div className={styles.additional_info_text}>{window.atob('WW91IENhbiBDYWxsIE1lIFN1c2FuIElmIEl0IE1ha2VzIFlvdSBIYXBweQ==')}</div>
                            </>
                        ) : (
                            <p>{t('AGE_CONFIRMATION_MESSAGE_TEXT')}</p>
                        )}
                        <button
                            className={cn(styles.age_confirmation_button, styles.ac_accept)}
                            onClick={(e) => ageConfirm()}
                            onKeyDown={(e) => KeyboardEventCheck(e, ageConfirm)}
                        >
                            {t('AGE_CONFIRMATION_MESSAGE_BUTTON_ACCEPT')}
                        </button>
                        <button
                            className={cn(styles.age_confirmation_button, styles.ac_decline)}
                            onClick={(e) => decline()}
                            onKeyDown={(e) => KeyboardEventCheck(e, decline)}
                        >
                            {t('AGE_CONFIRMATION_MESSAGE_BUTTON_DECLINE')}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default AgeConfirmation;
